module.exports = __webpack_public_path__ + "static/media/login.e7e8da8c.png";